import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "../components/ui/table";

export default function AuditLog() {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/audit-logs")
            .then((r) => setLogs(r.data))
            .catch((e) => toast.error(formatApiError(e)))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div data-testid="audit-page" className="space-y-8">
            <div>
                <div className="text-[11px] font-medium uppercase tracking-widest text-neutral-500">
                    Admin
                </div>
                <h1 className="mt-2 text-3xl font-medium tracking-tight text-neutral-900">
                    Audit log
                </h1>
                <p className="mt-1.5 text-sm text-neutral-500">
                    Every write action inside your organisation, in reverse chronological order.
                </p>
            </div>
            <div className="overflow-hidden rounded-lg border border-neutral-200 bg-white">
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead>Timestamp</TableHead>
                            <TableHead>Action</TableHead>
                            <TableHead>Entity</TableHead>
                            <TableHead>User</TableHead>
                            <TableHead>Meta</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody data-testid="audit-table-body">
                        {loading && (
                            <TableRow>
                                <TableCell colSpan={5} className="text-center text-sm text-neutral-500">
                                    Loading…
                                </TableCell>
                            </TableRow>
                        )}
                        {!loading && logs.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={5} className="text-center text-sm text-neutral-500">
                                    No entries yet.
                                </TableCell>
                            </TableRow>
                        )}
                        {logs.map((l) => (
                            <TableRow key={l.id}>
                                <TableCell className="mono text-xs text-neutral-500">
                                    {new Date(l.created_at).toLocaleString()}
                                </TableCell>
                                <TableCell className="font-medium">{l.action}</TableCell>
                                <TableCell className="text-neutral-600">
                                    {l.entity_type}
                                    {l.entity_id && (
                                        <span className="mono ml-1 text-[11px] text-neutral-400">
                                            {String(l.entity_id).slice(0, 8)}
                                        </span>
                                    )}
                                </TableCell>
                                <TableCell className="mono text-[11px] text-neutral-500">
                                    {l.user_id?.slice(0, 8) ?? "—"}
                                </TableCell>
                                <TableCell className="mono text-[11px] text-neutral-500">
                                    {Object.keys(l.meta || {}).length
                                        ? JSON.stringify(l.meta)
                                        : "—"}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
        </div>
    );
}
